type ContetProps = {
    center?: boolean,
    children?: JSX.Element | JSX.Element[];
}
const Content = ({ children, center }: ContetProps) => {
    return center ?
        <div className='flex flex-col self-center grow w-full h-full min-h-0'>
            <div className='flex self-center grow w-full h-full min-h-0'>
                <div className='flex flex-col self-center w-full grow h-full min-h-0'>
                    {children}
                </div>
            </div>
        </div>
        : <div className={`space-y-2`}>{children}</div>
}
export default Content